import request from "../utils/request"

export function generateRectificationDraft(data) {
  return request({ url: "/office/rectification/ai-draft", method: "post", data, timeout: 90000 })
}

export function fetchRectificationBatches() {
  return request({ url: "/office/rectification/batches", method: "get" })
}

export function fetchRectificationItems(batchId) {
  return request({ url: `/office/rectification/batches/${batchId}/items`, method: "get" })
}

export function saveRectificationBatch(data) {
  return request({ url: "/office/rectification/batches", method: "post", data })
}

export function setRectificationCompleted(issueId, completed) {
  return request({ url: `/office/rectification/items/${issueId}/completion`, method: "patch", data: { completed } })
}

export function setRectificationStatus(issueId, status) {
  return request({ url: `/office/rectification/items/${issueId}/status`, method: "patch", data: { status } })
}
